import { Button, Switch, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useToast, Divider, FormControl, FormLabel, Heading, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { ChatState } from "../../../Context/ChatProvider";


const LevelTable = ({ data, search, loading, setFetchAgain }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const [id, setId] = useState("");
	const [levelName, setLevelName] = useState("");
	const [price, setPrice] = useState('');
	const [picLoading, setPicLoading] = useState(false);
	const { user } = ChatState();

	const toast = useToast();

	const openModal = (levelInfo) => {
		setId(levelInfo ? levelInfo._id : "")
		setLevelName(levelInfo ? levelInfo.levelName : "");
		setPrice(levelInfo ? levelInfo.price : "");
		setPicLoading(false);
		onOpen()
	}

	const deleteLevel = async (id) => {


		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
				params: { id: id }

			};

			await axios.delete(
				'/api/level',
				config
			);

			toast({
				title: "Supprimé avec succès",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setFetchAgain(true);
		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
		}
	}



	const updateLevel = async () => {
		if (!levelName || !price) {
			toast({
				title: "Veuillez remplir tous les champs",
				status: "warning",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});
			setPicLoading(false);
			return;
		}
		setPicLoading(true);

		try {
			const config = {
				headers: {
					"Content-type": "application/json",
					Authorization: `Bearer ${user.token}`,
				},
			};
			await axios.put(
				"/api/level",

				{
					id,
					levelName,
					price
				},
				config
			);

			toast({
				title: "Mise à jour réussie",
				status: "success",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});



			setFetchAgain(true);



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: error.response.data.message,
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom",
			});

		}
		onClose();
	};


	return (
		<>
			{/* <Button ml={4} ref={finalRef}>
        I'll receive focus on close
    </Button> */}

			<Modal
				//initialFocusRef={initialRef}
				// finalFocusRef={finalRef}
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent m='auto'>
                <ModalHeader className="bg-gray-50 shadow-md text-black text-xl"><i className="fa-solid fa-layer-group text-2xl mr-1"></i> Level</ModalHeader>
                
                <ModalBody pb={6}>


                    <div className="mr-4">

                        <FormControl mt={4}>
                            <Input placeholder='Niveau' id='levelName' value={levelName}
                                onChange={(e) => setLevelName(e.target.value)} />
                        </FormControl>

                        <FormControl mt={4}>
                            <Input placeholder='Prix' id='price' value={price}
                                onChange={(e) => setPrice(e.target.value)} />
                        </FormControl>

                    </div>


                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='blue' mr={3}
                        onClick={updateLevel}
                        isLoading={picLoading}>
                        Enregistrer
                    </Button>
                    <Button onClick={onClose}>Annuler</Button>
                </ModalFooter>
            </ModalContent>
			</Modal>
			<TableContainer w={"full"} className='border'>
				<Table variant={"simple"} >

					<Thead>
						<Tr className="bg-gray-50 text-black">
							<Th textAlign={"center"}>Level</Th>
							<Th textAlign={"center"}>Prix</Th>
							<Th w={"24"}></Th>
						</Tr>
					</Thead>
					<Tbody >

						{data?.filter((level) => {
							return search.toLowerCase() === ''
								? level
								: level.levelName.toLowerCase().includes(search.toLowerCase());
						})
							.map((level, index) => (

								<Tr key={index} fontSize="sm">
									
									<Td textAlign={"center"}>{level.levelName}</Td>
									<Td textAlign={"center"}>{level.price}</Td>
									<Td >
										<Button bg='gray.50' onClick={() => { openModal(level) }}> <i className="fa-regular fa-pen-to-square text-blue-400 mr-2"></i> Modifier
										</Button>
										<Button fontSize={14} ml={2} bg='gray.50' onClick={() => deleteLevel(level._id)}  ><i className="fa-solid fa-trash text-red-500"></i></Button>
									</Td>
								</Tr>

							))}
					</Tbody>


				</Table>
				<div className="w-full  flex item-center p-6">
					{loading && <i className="fa-solid fa-circle-notch animate-spin m-auto text-xl"></i>}
					{!loading && data.length === 0 && <span className="text-md text-gray-300 m-auto">Aucun résultat.</span>}
				</div>
			</TableContainer>
		</>
	);


};

export default LevelTable;
